import { Badge, Button, Col, Drawer, Dropdown, Card, Flex, Form, Descriptions, Tag, Divider, Table, columns, Input, Layout, Modal, Popconfirm, Row, Select, Skeleton, Space, Tooltip, Typography, Upload, notification, theme } from 'antd';
import {
  SendOutlined,
  MoreOutlined,
  UnlockOutlined,
  EyeOutlined,
  LockOutlined,
  EditOutlined,
  VideoCameraOutlined,
  DeleteOutlined,
  MessageOutlined,
  SignatureOutlined,
  DownloadOutlined,
  FileZipOutlined,
  FileAddOutlined,
  DiffOutlined,
  InboxOutlined,
  UploadOutlined,
  CloseOutlined,
  FileDoneOutlined,
  CommentOutlined,
  FilePdfOutlined,
  CheckCircleOutlined, TeamOutlined, EnvironmentOutlined, CalendarOutlined, ClockCircleOutlined, FileTextOutlined

} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import CommitteeAPI from '../../../restAPI/CommitteeAPI';
import CalendarDataAPI from '../../../restAPI/CalendarDataAPI';
import dayjs from 'dayjs';
import NewMeetingDrawer from '../../../helperComponents/CreateNewMeeting/NewMeetingDrawer';
import ArchivedMeetingDetails from '../../../helperComponents/CreateNewMeeting/ArchivedOldMeetingDetails';
import { actionStateCapture, agendaCapture, agendaIDCapture, committeeCapture, commonInformationCapture, generalInformationCapture, screenEnded, screenStart, initialGeneralInformationCapture } from '../../../redux/slices/meetingSlice';
import MeetingAPI from '../../../restAPI/MeetingAPI';
import { useNavigate } from 'react-router-dom';
import { COLOR } from '../../../theme/constant';
import useCurrentCompany from '../../../hooks/useCurrentCompany';


const { Content } = Layout;
const { Title, Text } = Typography;
const { Dragger } = Upload;



export default function MyEventsPreview(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    token: { colorBgContainer, colorWarning, borderRadiusLG, colorBgLayout, colorSuccess },
  } = theme.useToken();
  const { companyId, token, role, userCompany } = useSelector(state => state.auth);

  const [current, setCurrent] = useState(0);
  const [value2, setValue2] = useState('on');
  const [actionState, setActionState] = useState('add');
  const [selectedMeetingDetails, setSelectedMeetingDetails] = useState(null);
  const [dot, setDot] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [openNewMeetingDrawer, setOpenNewMeetingDrawer] = useState(false);
  const [isPrevClickedToGeneral, setIsPrevClickedToGeneral] = useState(false);
  const [isPrevClickedToCommittee, setIsPrevClickedToCommittee] = useState(false);  
  const currentCompanyInfo = useCurrentCompany();
  const [originalDataObject, setOriginalDataObject] = useState({});
  const [selectedDays, setSelectedDays] = useState([]);
  const [tempDateValue, setTempDateValue] = useState(() => dayjs());
  const [meetingMinutesPayload, setMeetingMinutesPayload] = useState({
    meetingMinutes: "",
  });
  const [uploadingMinutes, setUploadingMinutes] = useState(false);
  const [showPopconfirm, setShowPopconfirm] = useState(false);


  // Drawer tabble

  const columns = [
    {
      title: 'Paper Name',
      dataIndex: 'paperName',
      key: 'paperName',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Paper Code',
      dataIndex: 'paperCode',
      key: 'paperCode',
    },
    {
      title: 'Paper No',
      dataIndex: 'paperNo',
      key: 'paperNo',
    },
    {
      title: 'Comments',
      dataIndex: 'commentsCount',
      key: 'commentsCount',
      render: (count) => (
        <Space>
          <CommentOutlined />
          <Text>{count}</Text>
        </Space>
      ),
    },
    {
      title: 'PDFs',
      dataIndex: 'pdfCount',
      key: 'pdfCount',
      render: (count) => (
        <Space>
          <FilePdfOutlined style={{ color: '#d4380d' }} />
          <Text>{count}</Text>
        </Space>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Publish' ? 'success' : 'warning'}>
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'View',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">

          <Button type="primary" icon={<EyeOutlined />} onClick={showPaperDrawer} />
        </Space>
      ),
    },
  ];

  const dataSource = [
    {
      key: '1',
      paperName: 'TT1',
      category: 'Category 3',
      paperCode: 'tt',
      paperNo: 1,
      commentsCount: 0,
      pdfCount: 5,
      status: 'Publish',
    },
    {
      key: '2',
      paperName: 'Paper2',
      category: 'Category 2',
      paperCode: '',
      paperNo: null,
      commentsCount: 0,
      pdfCount: 0,
      status: 'Pending',
    },
  ];


  const paperData = [
    { key: '1', documentName: 'TTI1', commentsCount: 0 },
    { key: '2', documentName: 'osdsd', commentsCount: 0 },
    { key: '3', documentName: 'xcxc', commentsCount: 0 },
    { key: '4', documentName: 'TTI2', commentsCount: 0 },
    { key: '5', documentName: 'minutes', commentsCount: 0 },
  ];

  const columnspaper = [
    {
      title: 'Document Name',
      dataIndex: 'documentName',
      key: 'documentName',
      //render: (text) => {text},
    },
    {
      title: 'Number of Comments',
      dataIndex: 'comments',
      key: 'comments',
      align: 'center',
      render: (count) => (
        <Tag color={count > 0 ? 'red' : 'default'}>{count}</Tag>
      ),
    },
    {
      title: 'View Pdf',
      key: 'view',
      align: 'center',
      render: () => (
        <Button type="link" icon={<EyeOutlined />}>
          View PDF
        </Button>
      ),
    },

  ];

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };


  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const handlePopconfirmOpen = (e) => {
    e.stopPropagation();
  };

  const handlePopconfirmClose = () => {
    setDropdownVisible(false);
  };

  const showNewMeetingDrawer = () => {
    setOpenNewMeetingDrawer(true);
  };
  const onCloseNewMeetingDrawer = () => {
    setOpenNewMeetingDrawer(false);
    dispatch(screenEnded());
    setActionState('add');
    setIsRecurring(false);
    setSelectedDays([]);
    setValue2('on');
    setCurrent(0);
    setIsPrevClickedToGeneral(false);
    setIsPrevClickedToCommittee(false);
    props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
  };

  const getCommitteeInfoForMeeting = async (actionState = 'add') => {
    if (!props.committeeId) {
      openNotificationWithIcon('error', 'Error', `Insufficent data to display meeting details.`, 'bottomLeft');
      return;
    };

    // const checkDateToHandleClick = moment(props.fullMeetingDetails.info.startDate).isSameOrAfter(moment(), 'minutes');
    const checkDateToHandleClick = moment(props.fullMeetingDetails.info.startDate).isSameOrAfter(moment().startOf('day'), 'minutes');
    if (!checkDateToHandleClick && actionState === 'edit') {
      openNotificationWithIcon('error', 'Meeting edit failed', `You can't edit previous meetings.`, 'bottomLeft');
      return;
    }

    if (actionState === 'view') {
      await getSingleMeetingInforByIdAndDate(actionState);
    } else {
      try {
        const response = await CommitteeAPI.getCommitteeById(props.committeeId, companyId, token);
        if (response.status === 200) {
          const committeeData = response.data.data;
          const isUserInCommittee = [committeeData.secretaryId, committeeData.assistantSecretaryId].includes(currentCompanyInfo?.userDetailsId);
          if (isUserInCommittee) {
            await getSingleMeetingInforByIdAndDate(actionState);
          } else {
            openNotificationWithIcon('error', 'Unauthorized', "You don't have the permission to edit a meeting.", 'bottomLeft');
          }
        }
      } catch (error) {
        if (error.response) {
          openNotificationWithIcon('error', 'Unauthorized', `${error.response.data}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'Failed', `Meeting edit failed`, 'bottomLeft');
        }
        console.error("getCommitteeInfoForMeeting error:", error);
      }
    }
  };

  const getSingleMeetingInforByIdAndDate = async (actionState) => {
    const { meetingId, meetingDate, originalDate } = props;
    if (!meetingId || !meetingDate || !originalDate) return;

    try {
      let response = null;
      if (actionState === 'view') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForMeetingView(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      } else if (actionState === 'edit') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForMeetingUpdate(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      } else if (actionState === 'editPaper') {
        response = await CalendarDataAPI.getMeetingsByIdAndDateForAgendaUpdate(
          meetingDate, meetingId, dayjs(originalDate), companyId, token
        )
      }

      if (response) {
        console.log('meeting details :', response);
        setSelectedMeetingDetails(response.data);
        setActionState(actionState);
        const { info, held, recurrence, participant, committeeType, committee, agenda, minute } = response.data.meeting;
        dispatch(screenStart());

        let generalInformation = null;

        if (actionState !== 'editPaper') {
          generalInformation = {
            info: {
              name: info.name,
            },
            schedule: {
              startDate: dayjs(info.startDate).toISOString(),
              endDate: dayjs(info.endDate).toISOString(),
            },
            held: {
              type: held.type,
              physical: {
                location: held?.physical?.location || '',
                room: held.physical?.room || ''
              },
              online: held.type === 'online' || held.type === 'hybrid' ? held.online.service : ''
            },
            recurrence: {
              status: recurrence.status,
              repeatEvery: recurrence.status ? {
                occurrence: recurrence?.repeatEvery?.occurrence || '',
                type: recurrence?.repeatEvery?.type || '',
                // dayOfWeek: recurrence?.repeatEvery?.type === 'weekly' ? recurrence?.repeatEvery?.dayOfWeek.map(Number).filter(value => !isNaN(value)).sort((a, b) => a - b) : [] || []
                dayOfWeek: recurrence?.repeatEvery?.type === 'weekly' && Array.isArray(recurrence?.repeatEvery?.dayOfWeek)
                  ? recurrence?.repeatEvery?.dayOfWeek.map(Number).filter(value => !isNaN(value)).sort((a, b) => a - b)
                  : []
              } : {},
              repeatEnd: {
                type: recurrence.status ? recurrence?.repeatEnd?.type : "on",
                onDate: recurrence.status && recurrence?.repeatEnd?.type === 'on' ? recurrence?.repeatEnd?.onDate : null,
                afterOccurrence: recurrence.status && recurrence?.repeatEnd?.type === 'after' ? recurrence?.repeatEnd?.afterOccurrence : null,
              }
            }
          };
        }


        const meetingCommonInfo = {
          meetingId: meetingId,
          meetingDate: meetingDate,
          originalDate: originalDate,
          originalUserDetailsId: participant.belong.originalUserDetailsId,
          secretaryId: committee?.secretaryId || null,
          assistantSecretaryId: committee?.assistantSecretaryId || null,
          meetingdateAndTime: actionState === 'view' ? dayjs(info.endDate).toISOString() : null,
          minute: actionState === 'view' ? minute : null,
          info: actionState === 'view' ? info : null,
          meetingStatus: response.data.meeting.status || 'publish',
          pdfMeetingDate:response.data.meetingDate,
          pdfOriginalMeetingDate:response.data.originalDate
        };

        const committeeMembersList = participant.members && participant.members.length > 0
          ? participant.members.map(member => (
            {
              userDetailsId: member._id,
              name: member.detail?.name || '',
              branch: member.detail?.branch?.name || '',
              designation: member.detail.designation,
              attendance: member.data.attendance,
              rsvp: member?.data?.attendance === "mandatory" ? "Yes" : member.data.rsvp.type,
              isDeletable: false,
              hasResponded: member.data.attendance === "optional" ? member.data.rsvp.type !== "Default" : false,
              isCommitteeMember: member?.data?.isCommitteeMember || false,
            }))
          : [];

        const committeeInformation = {
          participant: {
            committeeType: committeeType ? committeeType?._id : null,
            committeeId: committee?._id || null,
            committeeTypeName: committeeType?.name || null,
            committeeName: committee?.name || null,
            secretaryId: committee?.secretaryId || null,
            assistantSecretaryId: committee?.assistantSecretaryId || null,
            members: committeeMembersList,
          }
        };

        const mapAttachments = (attachments) => {
          return attachments.length > 0
            ? attachments.map((single) => {
              const isPdf = single.filePath
                ? single.filePath.split('.').pop().toLowerCase() === 'pdf'
                : false;
              const eSignatureRequestList =
                single.eSignature && single.eSignature.length > 0
                  ? single.eSignature
                    .filter((singleRequest) => singleRequest.isRequested)
                    .map((singleRequest) => singleRequest.userDetailsId)
                  : [];

              return {
                _id: single._id,
                key: single._id,
                id: single._id,
                name: single.name,
                created: single.timestamp,
                file: single.filePath,
                fileName: single.fileName || 'N/A',
                comment: single.comment,
                shareWith: single.shareWith,
                eSignature: {
                  members: eSignatureRequestList,
                },
                signatureRequestList: single.eSignature,
                // voting: single.voting,
                voting: {
                  ...single.voting,
                  end: {
                    ...single.voting.end,
                    customDate: single.voting.end?.date || null, // Wrapping date inside customDate
                  },
                },
                isPdf: isPdf,
                isAddedToDB: true,
                order: single.order,
                annotation: single.annotation || []
              };
            })
            : [];
        };

        if (actionState !== 'edit') {
          const mappedAgenda = ['editPaper', 'view'].includes(actionState) ? {
            _id: agenda._id,
            categories: agenda.categories.map((category) => ({
              _id: category._id,
              id: category._id,
              isAddedToDB: true,
              order: category.order || 1,
              categoryId: category._id,
              categoryName: category.name,
              items: category.items.map((item) => ({
                _id: item._id,
                id: item._id,
                isAddedToDB: true,
                paperName: item.name,
                name: item.name,
                order: item.order,
                code: item.code,
                paperCode: item.code,
                comment: item.comment,
                attachments: mapAttachments(item.attachments),
                status: item.status
              }))
            }))
          } : {}
          dispatch(agendaCapture(mappedAgenda))
        }
        dispatch(agendaIDCapture(agenda?._id));
        dispatch(generalInformationCapture(generalInformation));
        dispatch(initialGeneralInformationCapture(generalInformation));
        dispatch(commonInformationCapture(meetingCommonInfo));
        dispatch(committeeCapture(committeeInformation));

        const originalDataObject = {
          meetingDate,
          originalDate,
          ...generalInformation,
          ...committeeInformation,
        };
        // console.log('originalDataObject :', originalDataObject)
        setOriginalDataObject(originalDataObject);

        showNewMeetingDrawer();
      }
    } catch (error) {
      openNotificationWithIcon('error', 'Process failed', `Something went wrong.`, 'bottomLeft');
      console.error("getMeetingsByDateAndId error:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => setDot(prevDot => !prevDot), 500);
    return () => clearInterval(interval);
  }, []);

  const handleResponseIcon = () => {
    const checkMandatory = props.fullMeetingDetails?.participant?.member?.attendance === "mandatory";
    if (checkMandatory) {
      if (!props.triggerMeetings.includes(props.fullMeetingDetails._id)) {
        openNotificationWithIcon('info', 'Attendance Mandatory', `You can't change RSVP, because you have selected as mandatory participant.`, 'bottomLeft');
        props.setTriggerMeetings([props.fullMeetingDetails._id]);
      }
      return;
    }
    const checkDateToHandleClick = moment(props.fullMeetingDetails.info.startDate).isSameOrAfter(moment().startOf('day'), 'minutes');
    if (checkDateToHandleClick) {
      props.showSingleMeetingDrawer(props.selectedMeetingId, props.meetingDate, props.originalDate, props.status);
    } else {
      openNotificationWithIcon('error', 'Response adding failed', `Can't change previous meeting values.`, 'bottomLeft');
    }
  };

  const handleChangeMeetingState = async (changeState, scope = 'following') => {
    const { _id: meetingId, originalDate } = props.fullMeetingDetails;
    let changingState = changeState === 'inactive' ? 'unpublished' : 'published';

    let payload = {
      scope: scope,
      action: changeState === 'inactive' ? 'add' : 'remove',
      originalDate: originalDate
    };

    try {
      const response = await MeetingAPI.cancelMeeting(meetingId, payload, companyId, token);
      if (response.status === 200) {
        // openNotificationWithIcon('success', 'Successful', `Meeting ${changingState} successful.`, 'bottomLeft');
        openNotificationWithIcon('success', 'Successful', `The meeting has been ${changingState} successfully.`, 'bottomLeft');
        setTimeout(() => {
          // props.fetchMeetingsAccordingToTab(props.activeTab);
          props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
        }, 1500)
      } else {
        openNotificationWithIcon('error', 'Failed', `Meeting status change failed`, 'bottomLeft');
      }
    } catch (error) {
      openNotificationWithIcon('error', 'Failed', `The meeting could not be ${changingState}. Please try again later.`, 'bottomLeft');
      console.log('Error in handleChangeMeetingState : ', error);
    }
  };

  const handleChangeMeetingStatus = async (changeState) => {
    const { _id: meetingId, originalDate } = props.fullMeetingDetails;
    let payload = {
      status: changeState, originalDate
    }
    try {
      const response = await MeetingAPI.changeMeetingStatus(meetingId, payload, companyId, token)
      console.log('response :', response)
      if (response.status === 200) {
        openNotificationWithIcon('success', 'Successful', `Meeting status updated successfully.`, 'bottomLeft');
        // openNotificationWithIcon('success', 'Successful', `The meeting status has been ${changeState} successfully.`, 'bottomLeft');
        setTimeout(() => {
          // props.fetchMeetingsAccordingToTab(props.activeTab);
          props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
        }, 1500)
      } else {
        openNotificationWithIcon('error', 'Failed', `Meeting status change failed`, 'bottomLeft');
      }
    } catch (error) {
      openNotificationWithIcon('error', 'Failed', `The meeting status could not be changed. Please try again later.`, 'bottomLeft');
      console.log('error in change meeting status :', error);
    }
  }

  const handleDeleteMeeting = async () => {
    const { _id: meetingId, originalDate } = props.fullMeetingDetails;
    let payload = {
      scope: 'this',
      originalDate: originalDate
    };

    try {
      const response = await MeetingAPI.deleteSingleMeeting(meetingId, payload, companyId, token);
      if (response.status === 200) {
        openNotificationWithIcon('success', 'Successful', `The meeting has been deleted successfully.`, 'bottomLeft');
        setTimeout(() => {
          // props.fetchMeetingsAccordingToTab(props.activeTab);
          props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
        }, 1000)
      }
      else {
        openNotificationWithIcon('error', 'Failed', `Meeting delete failed`, 'bottomLeft');
      }
    } catch (error) {
      openNotificationWithIcon('error', 'Failed', `The meeting could not be deleted. Please try again later.`, 'bottomLeft');
      console.log('Error in delete meeting :', error);
    }
  };

  const [open, setOpen] = useState(false);
  const [openArchivedDrawer, setOpenArchivedDrawer] = useState(false);
  const [openPaperDrawer, setOpenPaperDrawer] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const showArchivedDrawer = () => {
    setOpenArchivedDrawer(true);
  };
  const showPaperDrawer = () => {
    setOpenPaperDrawer(true);
  };
  const onClose = () => {
    setOpen(false);
    setUploadingMinutes(false);
    // props.fetchMeetingsAccordingToTab(props.activeTab);
    props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
  };
  const onCloseArchivedDrawer = () => {
    setOpenArchivedDrawer(false);
    props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
  };
  const onClosePaperDrawer = () => {
    setOpenArchivedDrawer(false);
    props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
  };

  const allowedFileTypes = ["application/pdf"];

  const meetingMinutes = {
    name: 'file',
    multiple: false,
    beforeUpload: (file) => {
      const isAllowedFileType = allowedFileTypes.includes(file.type)
      if (!isAllowedFileType) {
        openNotificationWithIcon("error", "Upload failed", "Only PDF files are allowed.", "bottomLeft")
        return Upload.LIST_IGNORE;
      }
      setMeetingMinutesPayload({ meetingMinutes: file });

      // Prevent auto upload by returning false
      return false;
    }
  }

  const onMeetingMinutesClose = () => {
    setOpen(false);
    setMeetingMinutesPayload({ meetingMinutes: "" });
    setUploadingMinutes(false);
    // props.fetchMeetingsAccordingToTab(props.activeTab);
    props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
  }

  const deleteMeetingMinutes = async () => {
    const formData = { originalDate: props.fullMeetingDetails.originalDate };

    await MeetingAPI.deleteMeetingMinutes(props.meetingId, formData, companyId, token)
      .then((res) => {
        openNotificationWithIcon("success", "Successful", `Meeting minute deleted successfully.`, "bottomLeft");
        // Delay drawer closing to ensure notification is visible
        setTimeout(() => {
          setMeetingMinutesPayload({ meetingMinutes: "" });
          // props.fetchMeetingsAccordingToTab(props.activeTab);
          props.fetchMeetingsAccordingToTab(
            props.activeTab,
            props.dateRange && props.dateRange[0] ? props.dateRange[0] : null,
            props.dateRange && props.dateRange[1] ? props.dateRange[1] : null
          );
        }, 1500); // 1.5 second delay
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Meeting minutes deletion failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Meeting minutes deletion failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  };

  const uploadMeetingMinutesFile = async () => {
    setUploadingMinutes(true);

    const formData = new FormData();
    formData.append('file', meetingMinutesPayload.meetingMinutes);
    formData.append('originalDate', props.fullMeetingDetails.originalDate);

    await MeetingAPI.uploadMeetingMinutes(
      formData,
      companyId,
      props.meetingId,
      token
    )
      .then((res) => {
        openNotificationWithIcon('success', "Successful", `Meeting minute updated successfully.`, 'bottomLeft');
        // Delay drawer closing to ensure notification is visible
        setTimeout(() => {
          setOpen(false);
          setMeetingMinutesPayload({ meetingMinutes: "" });
          setUploadingMinutes(false);
          // props.fetchMeetingsAccordingToTab(props.activeTab);  
          props.fetchMeetingsAccordingToTab(props.activeTab, props.dateRange && props.dateRange[0] ? props.dateRange[0] : null, props.dateRange && props.dateRange[1] ? props.dateRange[1] : null);
        }, 1500); // 1.5 second delay
      })
      .catch((err) => {
      setUploadingMinutes(false);
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Meeting minutes creation failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Meeting minutes creation failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  };

  const onMeetingMinutesAdd = async () => {
    if (!meetingMinutesPayload.meetingMinutes) {
      //openNotificationWithIcon('error', 'Error', `Please select a file to upload.`, 'bottomLeft');
      return;
    }

    // Check if meeting minutes already exist
    if (props.fullMeetingDetails?.minute?.fileName) {
      setShowPopconfirm(true);
    } else {
      uploadMeetingMinutesFile();
    }
  }

  const handleConfirmUpload = () => {
    setShowPopconfirm(false);
    uploadMeetingMinutesFile();
  };

  const handleCancelUpload = () => {
    setShowPopconfirm(false);
  };

  return (
    <>
      <Skeleton active loading={loading}>
        {/* DFCC old meetings - Moved to Old Archive tab */}

        <Badge.Ribbon
          style={{ fontSize: '0.7em', lineHeight: '23px' }}
          text={props.fullMeetingDetails.status === 'unpublish' ? props.fullMeetingDetails.status.charAt(0).toUpperCase() + props.fullMeetingDetails.status.slice(1)
            : props.fullMeetingDetails.status === 'archive' ? props.fullMeetingDetails.status.charAt(0).toUpperCase() + props.fullMeetingDetails.status.slice(1)
              : props.fullMeetingDetails.status === 'held' ? "Meeting Held"
                : props.fullMeetingDetails.status === 'minutes' ? "Meeting Minutes Updated"
                  : props.status
          }
          color={
            props.fullMeetingDetails.status === 'unpublish' ? 'gray' :
              props.fullMeetingDetails.status === 'held' ? colorWarning :
                props.fullMeetingDetails.status === 'archive' ? COLOR.alizarin500 :
                  props.fullMeetingDetails.status === 'minutes' ? COLOR.peterRiver500 :
                    props.fullMeetingDetails.status === 'publish' ? (
                      props.status === 'RSVP' ? 'red' :
                        props.status === 'Yes' ? colorSuccess :
                          props.status === 'No' ? 'geekblue' :
                            'gold'
                    ) :
                      'gray'
          }
        >
          <div
            style={{
              // padding: 8,
              marginBottom: 8,
              // margin: '16px',
              padding: '12px 12px',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              cursor: 'pointer',
            }}
            onClick={(e) => {
              // Prevent event bubbling to child buttons
              e.stopPropagation();
              console.log('Meeting card clicked!');

              // Open meeting in view mode with same logic as View button
              // All users can now view meetings regardless of status
              getCommitteeInfoForMeeting('view');
              dispatch(actionStateCapture('view'));
            }}
          >
            <Flex justify='space-between' align='center' gap={16} style={{ minHeight: 76 }}>
              <Flex justify='start-flex' align='center' gap={16} style={{ width: '70%' }}>
                <Badge color={
                  props.fullMeetingDetails.status === 'unpublish' ? 'gray' :
                    props.fullMeetingDetails.status === 'held' ? colorWarning :
                      props.fullMeetingDetails.status === 'archive' ? COLOR.alizarin500 :
                        props.fullMeetingDetails.status === 'minutes' ? COLOR.peterRiver500 :
                          props.fullMeetingDetails.status === 'publish' ? (
                            props.status === 'RSVP' ? 'red' :
                              props.status === 'Yes' ? colorSuccess :
                                props.status === 'No' ? 'geekblue' :
                                  'gold'
                          ) :
                            'gray'
                } />
                <Flex vertical gap={8}>
                  <Text>{props.name}</Text>
                  <Text style={{ fontSize: 10 }}  >{props.date} | {props.time}</Text>
                </Flex>
              </Flex>
              <Flex align='center' justify='flex-end' gap={20} style={{ width: '30%' }}>
                {(
                  props.fullMeetingDetails.status === 'publish' && dayjs().isBefore(dayjs(props.fullMeetingDetails?.info?.startDate))
                ) && <Tooltip
                  title="Respond Now"
                  open={tooltipVisible}
                >
                    {
                      // props.meetingParticipation can be 'original' or 'signatory'
                      props.meetingParticipation === 'original' && (
                        <Badge dot={dot} offset={[0, 10]}>
                          <Button
                            type="text"
                            icon={<SendOutlined />}
                            onMouseEnter={() => setTooltipVisible(true)}
                            onMouseLeave={() => setTooltipVisible(false)}
                            onClick={(e) => {
                              e.stopPropagation();
                              setTooltipVisible(false);
                              handleResponseIcon();
                            }}
                          />
                        </Badge>
                      )
                    }
                  </Tooltip>}
                {
                  (!['archive'].includes(props.fullMeetingDetails?.status)
                    && props.fullMeetingDetails?.held?.type !== 'physical'
                    && (dayjs().isBefore(dayjs(props.fullMeetingDetails?.info.endDate)))
                    && props.fullMeetingDetails.status !== 'unpublish'
                  ) && (
                    <Tooltip title="Join Now">
                      <Button type="text" icon={<VideoCameraOutlined />} onClick={(e) => {
                        e.stopPropagation();
                        const link = props?.fullMeetingDetails?.held?.online?.link;
                        window.open(link, '_blank');
                      }} />
                    </Tooltip>
                  )
                }
                <Flex gap="middle" wrap="wrap">
                  {
                    // All users can now view meetings regardless of status
                    <Tooltip title="View">
                      <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        // size='small'
                        onClick={(e) => {
                          e.stopPropagation();
                          getCommitteeInfoForMeeting('view');
                          dispatch(actionStateCapture('view'));
                        }}
                      />
                    </Tooltip>
                  }
                  {
                    (!['archive'].includes(props.fullMeetingDetails?.status)) && (
                      <Tooltip title="Chat">
                        <Button
                          type="primary"
                          icon={<MessageOutlined />}
                          // size='small'
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/chat", {
                              state: {
                                chatMode: 'Group',
                                groupName: props.fullMeetingDetails?.info?.name,
                                fullData: props.fullMeetingDetails,
                                userDetailsId: currentCompanyInfo.userDetailsId,
                                chatId: props.fullMeetingDetails?.chatId
                              }
                            })
                          }}
                        />
                      </Tooltip>
                    )
                  }
                  {
                    (
                      (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                      && (dayjs().isBefore(dayjs(props.fullMeetingDetails?.info?.endDate)))
                      && (props.fullMeetingDetails?.status !== 'archive')
                    )
                    && (
                      <Tooltip title="Edit Meeting">
                        <Button
                          type="primary"
                          icon={<EditOutlined />}
                          // size='small'
                          style={{ backgroundColor: colorWarning }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropdownVisible(false);
                            getCommitteeInfoForMeeting('edit')
                            dispatch(actionStateCapture('edit'));
                          }}
                        />
                      </Tooltip>
                    )
                  }
                  {
                    (
                      (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                      && (dayjs().isBefore(dayjs(props.fullMeetingDetails?.info?.endDate)))
                      && (props.fullMeetingDetails?.status !== 'archive')
                    )
                    && (
                      <Tooltip title="Add/Edit Papers">
                        <Button
                          type="primary"
                          icon={<DiffOutlined />}
                          // size='small'
                          style={{ backgroundColor: COLOR.wisteria }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropdownVisible(false);
                            getCommitteeInfoForMeeting('editPaper')
                            dispatch(actionStateCapture('editPaper'));
                          }}
                        />
                      </Tooltip>
                    )
                  }
                  {
                    (
                      (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                      && (dayjs().isAfter(dayjs(props.fullMeetingDetails.info.endDate)))
                      && (!['unpublish', 'archive'].includes(props.fullMeetingDetails?.status))
                    ) && (
                      <Tooltip title="Archive Meeting">
                        <Popconfirm
                          title="Do you want to archive this meeting? It will no longer be accessible to other participants."
                          okText="Yes"
                          onConfirm={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            handleChangeMeetingStatus('archive')
                          }}
                          cancelText="No"
                          onCancel={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            openNotificationWithIcon('error', 'Abort', `Archive cancelled`, 'bottomLeft')
                          }}
                        >
                          <Button
                            // danger
                            type="primary"
                            icon={<FileZipOutlined />}
                            style={{ backgroundColor: COLOR.alizarin500 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePopconfirmOpen(e);
                            }}
                          />
                        </Popconfirm>
                      </Tooltip>
                    )
                  }
                  {!['archive', 'held', 'minutes'].includes(props.fullMeetingDetails?.status) &&
                    (
                      currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId
                    ) && (
                      props.fullMeetingDetails.status === 'unpublish' ? (
                        <Tooltip title="Publish">
                          <Popconfirm
                            title="Do you want to publish this meeting? It will become visible to all intended participants."
                            onConfirm={(e) => {
                              e?.stopPropagation?.();
                              handlePopconfirmClose();
                              handleChangeMeetingStatus('publish');
                            }}
                            okText="Yes"
                            cancelText="No"
                            onCancel={(e) => {
                              e?.stopPropagation?.();
                              handlePopconfirmClose();
                              openNotificationWithIcon('error', 'Abort', 'Publish cancelled', 'bottomLeft');
                            }}
                          >
                            <Button type="primary" disabled={props.activeTab == 1 ? true : false} icon={<UnlockOutlined />} onClick={(e) => {
                              e.stopPropagation();
                              handlePopconfirmOpen(e);
                            }} />
                          </Popconfirm>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Unpublish">
                          <Popconfirm
                            title="Do you want to unpublish the meeting? It will no longer be accessible to participants."
                            onConfirm={(e) => {
                              e?.stopPropagation?.();
                              handlePopconfirmClose();
                              handleChangeMeetingStatus('unpublish');
                            }}
                            okText="Yes"
                            cancelText="No"
                            onCancel={(e) => {
                              e?.stopPropagation?.();
                              handlePopconfirmClose();
                              openNotificationWithIcon('error', 'Abort', 'Unpublish cancelled', 'bottomLeft');
                            }}
                          >
                            <Button type="primary" icon={<LockOutlined />} onClick={(e) => {
                              e.stopPropagation();
                              handlePopconfirmOpen(e);
                            }} />
                          </Popconfirm>
                        </Tooltip>
                      )
                    )}
                  {
                    (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                    && (dayjs().isAfter(dayjs(props.fullMeetingDetails.info.endDate)))
                    && (['publish'].includes(props.fullMeetingDetails.status))
                    && (
                      <Tooltip title="Meeting Held">
                        <Popconfirm
                          title="Do you want to mark this meeting as held? This action cannot be undone."
                          onConfirm={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            handleChangeMeetingStatus('held');
                          }}
                          okText="Yes"
                          cancelText="No"
                          onCancel={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            openNotificationWithIcon('error', 'Abort', 'Make meeting held cancelled', 'bottomLeft');
                          }}
                        >
                          <Button type="primary" icon={<CheckCircleOutlined />} onClick={(e) => {
                            e.stopPropagation();
                            handlePopconfirmOpen(e);
                          }} />
                        </Popconfirm>
                      </Tooltip>
                    )
                  }
                  {
                    (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                    && (dayjs().isAfter(dayjs(props.fullMeetingDetails.info.endDate)))
                    && (['held'].includes(props.fullMeetingDetails.status))
                    && (props.fullMeetingDetails?.minute?.fileName !== null)
                    && (
                      <Tooltip title="Meeting Minute Updated">
                        <Popconfirm
                          title="Have you uploaded the final meeting minutes? Confirm to mark them as uploaded"
                          onConfirm={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            handleChangeMeetingStatus('minutes');
                          }}
                          okText="Yes"
                          cancelText="No"
                          onCancel={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            openNotificationWithIcon('error', 'Abort', 'Add meeting to meeting minutes updated cancelled', 'bottomLeft');
                          }}
                        >
                          <Button type="primary" icon={<FileDoneOutlined />} onClick={(e) => {
                            e.stopPropagation();
                            handlePopconfirmOpen(e);
                          }} />
                        </Popconfirm>
                      </Tooltip>
                    )
                  }
                  {
                    (
                      (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                      && (['held'].includes(props.fullMeetingDetails?.status))
                      && (dayjs().isAfter(dayjs(props.fullMeetingDetails.info.endDate)))
                    ) &&
                    <Tooltip title="Add Meeting Minutes">
                      <Button
                        type="primary"
                        icon={<FileAddOutlined />}
                        onClick={(e) => {
                          e.stopPropagation();
                          showDrawer();
                        }}
                        // size='small'
                        style={{ backgroundColor: COLOR.peterRiver500 }}
                      />
                    </Tooltip>
                  }
                  {
                    (
                      (currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.secretaryUserDetailsId || currentCompanyInfo?.userDetailsId === props.fullMeetingDetails.assistantSecretaryUserDetailsId)
                      && (['unpublish'].includes(props.fullMeetingDetails?.status))
                    ) && (
                      <Tooltip title="Delete">
                        <Popconfirm
                          title="Are you sure to delete this meeting?"
                          onConfirm={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            handleDeleteMeeting()
                          }}
                          okText="Yes"
                          onCancel={(e) => {
                            e?.stopPropagation?.();
                            handlePopconfirmClose();
                            openNotificationWithIcon('error', 'Abort', `Delete cancelled`, 'bottomLeft')
                          }}
                          cancelText="No"
                        >
                          <Button
                            danger
                            type="primary"
                            icon={<DeleteOutlined />}
                            // size='small'
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePopconfirmOpen(e);
                            }}
                          />
                        </Popconfirm>
                      </Tooltip>
                    )
                  }
                </Flex>

                {/* <Dropdown
                  menu={{
                    items
                  }}
                  trigger={['click']}
                  open={dropdownVisible}
                  onOpenChange={handleDropdownVisibleChange}
                >
                  <Button type='link' icon={<MoreOutlined />} />
                </Dropdown> */}

              </Flex>
            </Flex>
          </div>
        </Badge.Ribbon>

        {contextHolder}
        
        <NewMeetingDrawer
          openDrawer={openNewMeetingDrawer}
          closeDrawer={onCloseNewMeetingDrawer}
          current={current}
          setCurrent={setCurrent}
          actionState={actionState}
          setActionState={setActionState}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          isPrevClickedToGeneral={isPrevClickedToGeneral}
          isPrevClickedToCommittee={isPrevClickedToCommittee}
          setIsPrevClickedToGeneral={setIsPrevClickedToGeneral}
          setIsPrevClickedToCommittee={setIsPrevClickedToCommittee}
          isRecurring={isRecurring}
          setIsRecurring={setIsRecurring}
          value2={value2}
          setValue2={setValue2}
          originalDataObject={originalDataObject}
          selectedDate={props.selectedDate}
          setSelectedDate={setTempDateValue}
          selectedMeetinId={props.meetingId}
          meetingDate={props.meetingDate}
          originalDate={props.originalDate}
          openNotificationWithIconf={props.openNotificationWithIcondd}
        />
        <Drawer
          title="Add Meeting Minutes"
          closable={{ 'aria-label': 'Close Button' }}
          onClose={onClose}
          open={open}
          footer={[
            <Flex justify='flex-end' align='center' gap='large'>
              <Button onClick={onMeetingMinutesClose} disabled={uploadingMinutes} >
                Cancel
              </Button>
              <Popconfirm
                title="A Meeting Minutes document already exists. Do you want to replace it with the new file?"
                open={showPopconfirm}
                onConfirm={handleConfirmUpload}
                onCancel={handleCancelUpload}
                okText="Yes"
                cancelText="No"
                cancelButtonProps={{ disabled: uploadingMinutes }}
              >
                <Button type="primary" disabled={!meetingMinutesPayload.meetingMinutes || uploadingMinutes} loading={uploadingMinutes} onClick={onMeetingMinutesAdd}>
                  Add
                </Button>
              </Popconfirm>
            </Flex>
          ]
          }
        >
          {props.fullMeetingDetails.minute.fileName && (
            <Row>
              <Col span={24}>
                <Flex gap={20} justify='space-between' align='center' style={{
                  padding: '16px 24px',
                  // minHeight: 280,
                  background: colorBgLayout,
                  borderRadius: borderRadiusLG,
                  marginBottom: 16,
                }}>
                  <Flex vertical gap={4}>
                    <Text>{props.fullMeetingDetails.minute.fileName}</Text>
                    {/* <Text style={{ fontSize: 12 }}  >{props.date} | {props.time}</Text> */} {/** removed after discussion with roshan and sudath */}
                  </Flex>
                  <Tooltip title="Delete Meeting Minutes">
                    <Button onClick={deleteMeetingMinutes}
                      danger
                      type="primary"
                      icon={<DeleteOutlined />}
                    // size='small'
                    />
                  </Tooltip>
                </Flex>
              </Col>
            </Row>)}
          <Row>
            <Col span={24}>
              <Dragger {...meetingMinutes}>
                <p className="ant-upload-drag-icon">
                  <UploadOutlined />
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                {/** removed after discussion with roshan and sudath */}
                {/* <p className="ant-upload-hint">
                  Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                  banned files.
                </p> */}
              </Dragger>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {/* <Form layout='vertical' style={{ marginTop: 16 }}>
                <Form.Item label="Change Status" name="ChangeStatus">
                  <Select
                    defaultValue="active"
                    style={{ width: '100%' }}
                    options={[{ value: 'active', label: 'Active' }]}
                    placeholder="Select Meeting Status"
                  />
                </Form.Item>
              </Form> */}
            </Col>
          </Row>

        </Drawer>

        {/* Archived Meeting Details Drawer */}
        <ArchivedMeetingDetails
          open={openArchivedDrawer}
          onClose={onCloseArchivedDrawer}
          meetingData={null} // Will be populated with actual data from API later
        />

        {/* <Drawer
          title="Papers"
          closable={{ 'aria-label': 'Close Button' }}
          onClose={onClosePaperDrawer}
          open={openPaperDrawer}
          width={800}
          footer={[
            <Flex justify='flex-end' align='center' gap='large'>
              <Button onClick={onClosePaperDrawer} >
                Close
              </Button>
            </Flex>
          ]}
        >
          <Descriptions column={1} colon={false} layout="horizontal">
            <Descriptions.Item label={<Text strong>Committee: </Text>}>
              <Space>

                <Text>Test C2</Text>
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label={<Text strong>Meeting: </Text>}>
              <Space>

                <Text>-</Text>
              </Space>
            </Descriptions.Item>

            <Descriptions.Item label={<Text strong>Paper Category: </Text>}>
              <Space>

                <Text>Tee</Text>
              </Space>
            </Descriptions.Item>

            <Descriptions.Item label={<Text strong>Paper Name: </Text>}>
              <Text type="secondary">—</Text>
            </Descriptions.Item>

            <Descriptions.Item label={<Text strong>Paper Code: </Text>}>
              <Space>

                <Text>-</Text>
              </Space>
            </Descriptions.Item>

            <Descriptions.Item label={<Text strong>Paper No: </Text>}>
              <Text strong style={{ fontSize: '16px' }}>Test 11</Text>
            </Descriptions.Item>
            <Descriptions.Item label={<Text strong>Comment: </Text>}>
              <Space>

                <Text>-</Text>
              </Space>
            </Descriptions.Item>

            <Descriptions.Item label={<Text strong>Paper Status: </Text>}>
              <Tag icon={<FileTextOutlined />} color="processing">
                Publish
              </Tag>
            </Descriptions.Item>
          </Descriptions>
          <Divider />

          <Title level={5}>Submitted Papers</Title>
          <Table
            columns={columnspaper}
            dataSource={paperData}
            pagination={false}
            bordered
            size="middle"
            rowHoverable
            locale={{ emptyText: 'No documents available' }}
          />
        </Drawer> */}

      </Skeleton>
    </>
  );
}